export default __webpack_public_path__ + "static/media/dropbox.f07f9dd5.svg";